import { SectionIdEnum, SectionNameEnum } from 'app/features/Home/TravelInsurance/types';
import { SectionIdEnum as lifeSectionIdEnum, SectionNameEnum as lifeSectionNameEnum } from 'app/features/Home/LifeInsurance/types';

/**
 * @description 旅遊險首頁 Menu
 */
export const HomeTravelInsuranceMenu = [
  { target: SectionIdEnum.IndexShowcase, text: SectionNameEnum.IndexShowcase },
  { target: SectionIdEnum.ProductFeatures, text: SectionNameEnum.ProductFeatures },
  { target: SectionIdEnum.InsuranceCoverages, text: SectionNameEnum.InsuranceCoverages },
  { target: SectionIdEnum.PremiumEvalCalculation, text: SectionNameEnum.PremiumEvalCalculation },
  { target: SectionIdEnum.RecommendationPlans, text: SectionNameEnum.RecommendationPlans },
  { target: SectionIdEnum.InsureLimits, text: SectionNameEnum.InsureLimits },
  { target: SectionIdEnum.InsureRegulations, text: SectionNameEnum.InsureRegulations },
  { target: SectionIdEnum.ClaimCases, text: SectionNameEnum.ClaimCases },
  { target: SectionIdEnum.InsuranceQA, text: SectionNameEnum.InsuranceQA },
  { target: SectionIdEnum.MoreProducts, text: SectionNameEnum.MoreProducts }
];

/**
 * @description 定期壽險首頁 Menu
 */
export const HomeLifeInsuranceMenu = [
  { target: lifeSectionIdEnum.IndexShowcase, text: lifeSectionNameEnum.IndexShowcase },
  { target: lifeSectionIdEnum.ProductFeatures, text: lifeSectionNameEnum.ProductFeatures },
  { target: lifeSectionIdEnum.InsuranceCoverages, text: lifeSectionNameEnum.InsuranceCoverages },
  { target: lifeSectionIdEnum.PremiumEvalCalculation, text: lifeSectionNameEnum.PremiumEvalCalculation },
  { target: lifeSectionIdEnum.RecommendationPlans, text: lifeSectionNameEnum.RecommendationPlans },
  { target: lifeSectionIdEnum.InsureLimits, text: lifeSectionNameEnum.InsureLimits },
  { target: lifeSectionIdEnum.InsureRegulations, text: lifeSectionNameEnum.InsureRegulations },
  { target: lifeSectionIdEnum.ClaimCases, text: lifeSectionNameEnum.ClaimCases },
  { target: lifeSectionIdEnum.InsuranceQA, text: lifeSectionNameEnum.InsuranceQA },
  { target: lifeSectionIdEnum.MoreProducts, text: lifeSectionNameEnum.MoreProducts }
];
